import type * as currentCart from '@wix/auto_sdk_ecom_current-cart-v-2';
import { EcomPlatformViewerScriptContext } from '../../viewer-script/types';
import { SPECS } from '../../constants';
import type { ExpressCheckoutSettings } from '../types';

export function createInternalPublicApi({
  context,
}: {
  context: EcomPlatformViewerScriptContext;
}) {
  /* istanbul ignore next */
  const getExpressCheckoutSettings =
    async (): Promise<ExpressCheckoutSettings> => {
      const ecommerceSettings =
        await context.eCommerceSettingsService?.getEcommerceSettings();
      return {
        taxOnProduct: Boolean(ecommerceSettings?.tax?.taxIncludedInItemPrices),
        isExpressSupported:
          !ecommerceSettings?.checkoutSettings?.checkoutFields
            ?.delayCaptureEnabled,
        hasPolicies: Boolean(
          ecommerceSettings?.checkoutSettings?.checkoutPolicies
            ?.termsAndConditions?.visible,
        ),
        requirePolicyAgreement: Boolean(
          ecommerceSettings?.checkoutSettings?.checkoutFields
            ?.policyAgreementCheckbox?.visible,
        ),
        isPremium: Boolean(ecommerceSettings?.isPremium),
        canBusinessShip:
          (ecommerceSettings?.delivery?.countries?.length ?? 0) > 0 ||
          !!ecommerceSettings?.delivery?.restOfWorld,
      };
    };

  return {
    calculateCart: (
      ...args: Parameters<typeof context.cartService.calculateCart>
    ) => context.cartService.calculateCart(...args),
    updateCart: (...args: Parameters<typeof context.cartService.updateCart>) =>
      context.cartService.updateCart(...args),
    setDeliveryMethod: (
      ...args: Parameters<typeof context.cartService.setDeliveryMethod>
    ) => context.cartService.setDeliveryMethod(...args),
    removeDeliveryMethod: (
      ...args: Parameters<typeof context.cartService.removeDeliveryMethod>
    ) => context.cartService.removeDeliveryMethod(...args),
    placeOrder: (...args: Parameters<typeof context.cartService.placeOrder>) =>
      context.cartService.placeOrder(...args),
    expressCheckout: {
      settings: getExpressCheckoutSettings,
    },
    addLineItemsToCurrentCart: async (
      options: currentCart.AddLineItemsToCurrentCartOptions,
    ) => {
      if (
        !context.siteStore.experiments.enabled(
          SPECS.CallCartV2FromCartComponents,
        )
      ) {
        await context.currentCartService.addToCurrentCartV1({
          lineItems: options.catalogItems,
        });
        return;
      }
      await context.currentCartService.addLineItemsToCurrentCart(options);
    },
  };
}
